import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Box, Button } from "@mzc-pdc/ui";
import { useMediaQuery } from "@mui/material";
import { IconForward, ImageErrorInfo } from "@mzc-cloudplex/icons";
import Typography from "@components_v2/typography/typography";
import theme from "@styles/theme";

const MobileNotSupported = () => {
    const { t } = useTranslation();
    const isMdUp = useMediaQuery(theme.breakpoints.up("md"));
    const iconSize = isMdUp ? 90 : 60;
    const titleVariant = isMdUp ? "h1" : "h3";
    const descriptionVariant = isMdUp ? "h4" : "body1_400";

    const handleGoBack = useCallback(() => {
        if (window.history.length > 1) {
            window.history.back();
        } else {
            window.location.href = "/";
        }
    }, []);

    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
                width: "100%",
                padding: theme.spacing(5),
                backgroundColor: theme.palette.background.default,
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: theme.spacing(4),
                    textAlign: "center",
                    width: "100%",
                }}
            >
                <ImageErrorInfo width={60} height={60} style={{ width: iconSize, height: iconSize }} />

                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: theme.spacing(1.5),
                    }}
                >
                    <Typography variant={titleVariant} color={theme.palette.greySecondary.main}>
                        {t(`common::msg::This page is not supported on mobile.`)}
                    </Typography>

                    <Typography
                        variant={descriptionVariant}
                        color={theme.palette.greySecondary[600]}
                        sx={{ fontWeight: 400 }}
                    >
                        {t(`common::msg::Please use the button below to go back to the previous page.`)}
                    </Typography>
                </Box>

                <Button
                    variant="contained"
                    color="primary"
                    size={isMdUp ? "large" : "medium"}
                    endIcon={<IconForward size={20} />}
                    onClick={handleGoBack}
                    sx={{
                        paddingX: theme.spacing(2.5),
                        height: 40,
                        borderRadius: theme.spacing(0.375),
                        textTransform: "none",
                    }}
                >
                    {t(`common::label::Go to previous page`)}
                </Button>
            </Box>
        </Box>
    );
};

export default MobileNotSupported;
